var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 150,
    viewBox: "0 0 136 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136 149.357H115.705C114.368 139.625 112.73 128.516 112.73 128.516C112.73 128.516 111.909 137.684 110.91 149.357H29.7063C28.9655 138.859 28.0736 131.006 27.7506 130.846C27.2853 130.611 24.3873 139.925 21.9841 149.357H0C5.65383 124.963 16.1999 85.8258 22.2982 83.4814C30.9746 80.138 66.3673 69.2139 66.3673 69.2139H86.5646C86.5646 69.2139 122.452 79.4693 125.792 90.6194C128.447 99.5054 134.302 128.807 136 149.357Z",
    fill: "#91D8BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4285 3.81931C78.4285 3.81931 97.2898 6.7767 94.418 36.1489C91.5461 65.5211 74.8986 63.1136 73.7872 63.0838C72.6729 63.054 57.0746 63.6194 55.8594 27.7578C55.8594 27.7578 55.326 1.23947 78.4285 3.81931Z",
    fill: "#EEA987"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5083 55.4578C85.5083 55.4578 84.9964 67.7595 86.1578 70.4229C87.3162 73.0859 70.7936 81.64 60.7156 72.1073C60.7156 72.1073 63.1495 58.7381 62.4737 53.9995C61.795 49.261 85.5083 55.4578 85.5083 55.4578Z",
    fill: "#EEA987"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4949 28.9271C94.4949 28.9271 96.3693 26.6621 97.0551 28.9551C97.7435 31.2481 94.148 41.4938 94.3847 41.9535C94.3847 41.9535 94.0405 42.8426 93.5914 42.353C93.1423 41.8634 94.4949 28.9271 94.4949 28.9271Z",
    fill: "#EEA987"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7646 28.0056C56.7646 28.0056 54.8254 25.707 54.0577 27.9773C53.29 30.2479 56.9039 40.5375 56.648 40.9907C56.648 40.9907 56.9949 41.8845 57.4783 41.4062C57.9617 40.9282 56.7646 28.0056 56.7646 28.0056Z",
    fill: "#EEA987"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5953 33.4999L91.886 37.1553C91.886 37.1553 91.9603 29.1414 91.5261 27.8849C91.0919 26.6284 90.4257 22.7897 90.0629 21.8843C89.7001 20.9792 73.8099 16.4859 59.7725 23.1963C59.7725 23.1963 60.3911 28.9589 59.0469 29.4718C57.6996 29.9846 58.3599 38.8571 58.3599 38.8571L56.1323 36.3205C56.1323 36.3205 52.7211 13.3308 53.5628 10.9345C54.4074 8.53832 57.09 -5.86786 85.8844 2.68414C85.8844 2.68414 94.863 0.765356 96.6652 7.01956C98.4675 13.2735 94.5953 33.4999 94.5953 33.4999Z",
    fill: "#D98B52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9997 69.3058C86.9997 69.3058 91.1371 70.2214 73.8239 87.4282C73.8239 87.4282 61.5442 73.341 61.9418 70.9816C62.3394 68.6224 86.9997 69.3058 86.9997 69.3058Z",
    fill: "#EEA987"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0718 87.5288L78.9707 95.929L93.5003 71.1875L87.2064 66.7861L74.0718 87.5288Z",
    fill: "#24B275"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0727 87.7286L62.4478 69.2139L55.8584 73.4531L67.6731 95.9282L74.0727 87.7286Z",
    fill: "#24B275"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0481 139.398C70.1953 142.162 70.2614 145.552 70.2704 149.357H69.5913C69.5853 145.567 69.5192 142.185 69.3719 139.431C68.2631 118.646 73.3776 93.356 73.4106 87.4287L74.0717 87.5574C74.0387 93.4844 68.9392 118.703 70.0481 139.398Z",
    fill: "#24B275"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5728 60.2283C65.5728 60.2283 70.2091 65.2498 76.7589 63.9106C83.3087 62.5714 86.2156 59.5 86.2156 59.5C86.2156 59.5 83.6307 66.1412 76.0598 66.7489C68.4858 67.3567 65.5728 60.2283 65.5728 60.2283Z",
    fill: "#C78D71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIllustration);
export default __webpack_public_path__ + "static/media/person-illustration.d14f1fa31ddeb8d5cd4e67f7a3fc900e.svg";
export { ForwardRef as ReactComponent };